import { z } from 'zod';

import type { DateRangeType } from '@/js/libs/ui/src/V2';

export type NotificationsFilterFields = {
  showRead: boolean;
  search: string;
  period: DateRangeType | null;
};

export const notificationsQueryParamsSchema = z.object({
  search: z.string().optional(),
});

export type NotificationsQueryParams = z.infer<typeof notificationsQueryParamsSchema>;
